import styled from 'styled-components';

export const ChartsWrapper = styled('div')`
	padding-left: 1rem;
	padding-right: 1rem;
	padding-top: 1rem;
	padding-bottom: 1rem;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	grid-auto-rows: 240px; /* height of each small tile */
	gap: 16px;
	width: calc(100% - 2rem);
	height: calc(100% - 2rem);
`;

export const FeatureChart = styled('div')`
	grid-row: span 2; /* twice the height */
	background: #0f2639; /* card styling (tweak as you like) */
	border-radius: 12px;
	min-height: 0; /* let the chart fill */
	display: flex;
	flex-direction: column;

	/* Responsive: on narrow screens let it flow like a normal tile */
	@media (max-width: 900px) {
		grid-column: 1 / -1; /* full width */
		grid-row: auto;
	}
`;

export const SmallChart = styled('div')`
	background: #0f2639;
	border-radius: 12px;
	padding: 12px;
	min-height: 0;
	display: flex;
	flex-direction: column;
`;

export const TrendChart = styled('div')`
	grid-row: span 2;                  /* twice the height */
	grid-column: span 2;
	background: #0f2639;               /* card styling (tweak as you like) */
	border-radius: 12px;
	min-height: 0;                     /* let the chart fill */
	display: flex;
	flex-direction: column;
	
	/* Responsive: on narrow screens let it flow like a normal tile */
	@media (max-width: 900px) {
		grid-column: 1 / -1;             /* full width */
		grid-row: auto;
`;
